import type { FC } from 'react';
import { useIntl } from 'react-intl';

import ContentBlock from '../../components/ContentBlock';
import messages from '../SingleProduct.messages';

const AdditionalInfo: FC<{
  contentInfo: string | null | undefined;
  variantInfo: string | null | undefined;
}> = ({ contentInfo, variantInfo }) => {
  const intl = useIntl();
  const htmlContent: string[] = [];

  if (contentInfo) {
    htmlContent.push(contentInfo);
  }

  if (variantInfo) {
    htmlContent.push(variantInfo);
  }

  return htmlContent.length > 0 ? (
    <ContentBlock
      title={intl.formatMessage(messages.additionalInformationTitle)}
      innerHtml={htmlContent}
    />
  ) : null;
};

export default AdditionalInfo;
